namespace Ir.Components.Workbook.Settings.WidgetVisualSettings {
    interface IViewModel {
        config: WorkbookConfig;
        dxScrollConfig: any;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        this.config = params.config as WorkbookConfig;
        this.dxScrollConfig = {
            useNative: false,
        };

        //NOT USED
    }
}